import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CalendarIcon } from 'lucide-react';
export function Proof() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy py-20 px-6 md:px-12" data-id="element-80">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-81">
        <div className="bg-dark-navy-light border-l-4 border-amber-cta p-8 md:p-12 rounded-lg space-y-6" data-id="element-82">
          <div className="flex items-center gap-3 text-amber-cta" data-id="element-83">
            <CalendarIcon className="w-8 h-8" data-id="element-84" />
            <h3 className="text-2xl md:text-3xl font-bold" data-id="element-85">
              What Changes in 7 Days
            </h3>
          </div>
          <p className="text-lg md:text-xl text-stone-300 leading-relaxed" data-id="element-86">
            Most readers report a profound sense of "lightness" and a reduction
            in symptom intensity within the first week of identifying their core
            emotional conflict. Once the "mystery" of the pain is gone, the
            body's natural healing systems finally have the space to work
            without interference.
          </p>
        </div>
      </motion.div>
    </section>;
}